import { TOGGLE_LIGHTS, TOGGLE_SPACE, TOGGLE_DARK_MODE } from './actionTypes';

// getLocalStorageTheme is the thunk action creator
// the returned function is the thunk function
// starting with (dispatch) => { ... }
// the thunk function is what will get called by redux-thunk middleware and 
// redux thunk will pass the dispatch function as an argument and the getState function as the second argument (if we need it)
export const getLocalStorageTheme = () => (dispatch) => {
  const lightsOn = JSON.parse(localStorage.getItem('lightsOn') ?? 'false'); // default to false if not set in localStorage
  const spaceOn = JSON.parse(localStorage.getItem('spaceOn') ?? 'false'); // default to false if not set in localStorage
  const darkMode = JSON.parse(localStorage.getItem('darkMode') ?? 'true'); // default to false if not set in localStorage (i.e. if it's null or undefined))
  dispatch(gotLocalStorageTheme({ lightsOn: lightsOn, spaceOn: spaceOn, darkMode: darkMode })); // dispatch the action to set the theme in our Redux store
};

// this function will be dispatched by the thunk function after it gets the theme from localStorage
// in other words, we'll call dispatch with the return value of this function.
// theme is the arg, and the parameter is the object with the lightsOn and spaceOn values that we got from localStorage
const gotLocalStorageTheme = (theme) => {
  return {
    type: 'GOT_LOCAL_STORAGE_THEME',
    payload: theme,
  }
};


// toogle lights thunk action creator
export const toggleLights = () => (dispatch, getState) => {
  const { lightsOn } = getState();
  const nextLightsOn = !lightsOn;
  localStorage.setItem('lightsOn', JSON.stringify(nextLightsOn));
  dispatch(toggledLightsAction(nextLightsOn));
};


const toggledLightsAction = (lightsOn) => {
  return {
    type: TOGGLE_LIGHTS,
    payload: lightsOn,
  };
};

// toogle space thunk action creator
export const toggleSpace = () => (dispatch, getState) => {
  const { spaceOn } = getState();
  const nextSpaceOn = !spaceOn;
  localStorage.setItem('spaceOn', JSON.stringify(nextSpaceOn));
  dispatch(toggledSpaceAction(nextSpaceOn));
};

const toggledSpaceAction = (spaceOn) => {
  return {
    type: TOGGLE_SPACE,
    payload: spaceOn,
  };
};

// toogle dark mode thunk action creator
export const toggleDarkMode = () => (dispatch, getState) => {
  const { darkMode } = getState();
  const nextDarkMode = !darkMode;
  localStorage.setItem('darkMode', JSON.stringify(nextDarkMode));
  dispatch(toggledDarkModeAction(nextDarkMode));
};

const toggledDarkModeAction = (darkMode) => {
  return {
    type: TOGGLE_DARK_MODE,
    payload: darkMode,
  };
};